import { requestJoinFuneralApi } from "@/apis/funeral_api";

import {
  deleteFuneralTokenInLocalStorage,
  setTokenInLocalStorage,
  setFuneralInfoLocalStorage
} from "@/utils/oauth";

import { deleteAccessTokenInHeader } from "@/apis/common_api";

import store from "@/store";
import router from "@/router";
import { requestToken } from "../apis/auth_api";
import User from "../apis/user";
import FuneralClient from "../apis/funeralClient";

const client = new FuneralClient();
const user = new User(client);

const state = {
  accessToken: localStorage.getItem("access_token"),
  type: "funeral",
  funeral: {
    id: localStorage.getItem("funeralId"),
    userId: localStorage.getItem("funeralUserId"),
    name: localStorage.getItem("funeralName"),
    phone: localStorage.getItem("funeralPhone"),
    Account: localStorage.getItem("funeralAccount"),
    SecurityNumber: localStorage.getItem("funeralSecurityNumber"),
    marketingAgree: localStorage.getItem("funeralMarketingAgree"),
    addr: localStorage.getItem("funeralAddr"),
    addrName: localStorage.getItem("funeralAddrName"),
    addrX: localStorage.getItem("funeralAddrX"),
    addrY: localStorage.getItem("funeralAddrY")
  },
  isFuneralAuthenticated:
    localStorage.getItem("access_type") === "funeral" &&
    localStorage.getItem("access_token")
};
const resetToken = state => {
  deleteFuneralTokenInLocalStorage();
  deleteAccessTokenInHeader();
  state.accessToken = null;
};

const getters = {
  isFuneralAuthenticated(state) {
    return state.isFuneralAuthenticated;
    // const accessType = localStorage.getItem("access_type");
    // if (state.type !== accessType) {
    //   return false;
    // }
    // if (!state.accessToken) {
    //   return false;
    // }
    // const token = state.accessToken.split("Bearer ")[1];

    // if (token === "undefined") {
    //   return false;
    // }

    // return true;
    // return state.director.id !== null ? true : false;
  },
  funeralInfo(state) {
    return state.funeral;
  }
};

const mutations = {
  LOGIN(state) {
    // state.accessToken = localStorage.getItem("access_token");
    state.isFuneralAuthenticated = true;

    router.push("/");
    store.dispatch("REQUEST_OBITUARY_ALL_LIST");
  },
  LOGOUT_FUNERAL(state) {
    resetToken(state);
    state.funeral = null;
    state.isFuneralAuthenticated = false;
    store.commit("REQUEST_OBITUARY_ALL_LIST_INIT");
  },

  // new
  FUNERAL_DETAIL(state, data) {
    state.funeral = data.resultFuneral;
  },

  SET_FUNERAL_ACCESS_TOKEN(state, data) {
    state.accessToken = data;
    state.isFuneralAuthenticated = true;
  }
};

const actions = {
  async REQUEST_LOGOUT_FUNERAL({ commit }) {
    try {
      commit("START_LOADING");
      const data = await user.logout();
      commit("LOGOUT_FUNERAL");
      router.replace("/funeral/loginDo");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // new
  async REQUEST_FUNERAL_JOIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const res = await requestJoinFuneralApi(parameter);

      if (res?.data?.result !== "success") {
        return alert(res.data.message);
      }

      router.replace("/funeral/loginDo");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_FUNERAL_LOGIN({ commit }, parameter) {
    try {
      commit("START_LOADING");
      // 엑세스 토큰 발급
      const token = await requestToken(parameter);

      if (token.data?.result !== "success") {
        alert(token.data.message);

        return;
      }
      await setTokenInLocalStorage({ ...token.data, type: parameter.type });

      await user.setToken(token.data.access_token);

      const data = await user.login(parameter.user);

      if (data?.result !== "success") {
        alert(data.message);
        return;
      }

      setFuneralInfoLocalStorage(data.resultFuneral);
      commit("FUNERAL_DETAIL", data);

      if (data.resultFuneral.password === "0000") {
        router.push("/passwordSetting");
        return;
      }

      window.location.reload();
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  },

  // nes
  async FUNERAL_DETAIL({ commit, state }) {
    try {
      commit("START_LOADING");
      const data = await user.getDetail();
      // setMemberInfoLocalStorage(getMember.data.resultMember);

      if (data?.result !== "success") {
        alert(data.message);
        router.push("/login");
        return;
      }

      commit("FUNERAL_DETAIL", data);
    } catch (error) {
      console.error(error);
    } finally {
      commit("END_LOADING");
    }
  },

  // new - 회원탈퇴
  async REQUEST_DELETE_FUNERAL({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.delete(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      alert("탈퇴가 완료되었습니다.");
      commit("LOGOUT");
      router.push("/login");
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert(e);
    } finally {
      commit("END_LOADING");
    }
  },
  // new
  async REQUEST_CHANGE_MARKET_AGREE_FUNERAL({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.changeMarketingAgree(parameter);
      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("FUNERAL_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },

  async REQUEST_FUNERAL_ADD_ACCOUNT({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addAccount(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("FUNERAL_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  },
  async REQUEST_FUNERAL_ADD_SECURITY_NUMBER({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await user.addSecurityNumber(parameter);

      if (data.result !== "success") {
        return alert(data.message);
      }

      commit("FUNERAL_DETAIL", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }

      console.error(e);

      alert("서비스 오류가 있습니다. 관리자에게 문의해주세요");
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
